RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, s) {
    'use strict';

    views.Post = RivalIQ.views.LayoutView.extend({
        template: '#socialPostViewTemplate',
        className: 'container-fluid',

        ui: {
            likelyPromotedText: '.likely-promoted-text',
            infoBubbles: '.fa-info-circle'
        },

        regions: {
            metricsRegion: '.metrics-region',
            postTagPills: '.post-tag-pills'
        },

        categories: ['post_analysis', 'reactions'],

        loadData: function () {
            const me = this;
            const def = me.getOption('metric');

            return def.fetch().done(function (metric) {
                me.metric = metric;
                me.model = metric.getValue();
            });
        },

        serializeData: function () {
            const me = this;
            const post = me.model;

            const messageWithParagraphs = _.map((post.get('message') || '').split(/\n+/), function (para) {
                return $.tagHtml('p', {
                    text: para
                });
            }).join('\n');

            const postJson = post.toJSON();
            postJson.canonicalUrl = postJson.canonicalUrl || null;
            postJson.postTags = me.getOption('postTags') || [];

            const isInstagramVideoPost = (post.get('source') === RivalIQ.enums.sources.INSTAGRAM && _.includes(['video', 'reel'], post.get('type').toLowerCase()));
            const useCdnThumbnail = App.utils.shouldUseCdnThumbnail(postJson.useThumbnailUrl, postJson.image);
            const timezone = me.metric.get('timezone');
            const publishedAtTz = RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, postJson.published_at);
            const capturedAtTz = RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, postJson.captured_at);

            const publishedAtStr = `${RivalIQ.utils.timezone.getDateInTimezone(timezone, postJson.published_at).format('MMM D, YYYY LT')} ${publishedAtTz}`;
            const capturedAtStr = `${RivalIQ.utils.timezone.getDateInTimezone(timezone, postJson.captured_at).format('MMM D, YYYY LT')} ${capturedAtTz}`;

            return _.extend(postJson, {
                message: messageWithParagraphs,
                isFocus: post.get('company_id') === RivalIQ.state.utils.getFocusedCompanyId(),
                showLink: App.utils.shouldShowLink(post),
                linkTitle: postJson.postedTitle || postJson.linkTitle,
                instagramVideo: (isInstagramVideoPost ? App.utils.makePreviewVideoUrl(postJson.display.video || postJson.display.image) : null),
                publishedAtStr: publishedAtStr,
                capturedAtStr: capturedAtStr,
                useCdnThumbnail: useCdnThumbnail,
                image: useCdnThumbnail ? postJson.image : postJson.imageLarge || postJson.image || postJson.platformImageUrl || _.get(postJson, ['display', 'html', 'imageUrl'])
            });
        },

        templateHelpers: function () {
            const me = this;
            const postSource = me.model.get('source');
            const postPromotedLikelyhood = me.model.get('promoted_likelyhood');
            const hasLikelyPromoted = RivalIQ.state.account.get('plan').has_likely_promoted;

            return _.extend({
                s: s,
                channel: RivalIQ.data.channels.get(postSource),
                isLikelyPromoted: (hasLikelyPromoted &&
                    postPromotedLikelyhood >= RivalIQ.enums.likelyPromoted.threshold),
                likelyPromotedDescription: RivalIQ.strings.likely_promoted_description
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        getPostHelperData: function () {
            const me = this;
            return me.model.attributes;
        },

        onRenderLoaded: function () {
            const me = this;

            me.ui.infoBubbles.popover();
            me.ui.likelyPromotedText.popover();

            // NOTE: column picker is incompatible with universal api
            me.metric = me.metric.build({
                useUniversalMetricsApi: false
            });

            // NOTE categories here are additional groups of properties we wish to curate in, if present
            me.metricsRegion.show(new RivalIQ.apps.Dashboard.widgets.table.MetricDisplay({
                metric: me.metric,
                type: me.model.get('type'),
                categories: me.getOption('categories'),
                enableUpsell: true
            }));

            if (me.options.showPostTags) {
                me.postTagPills.show(new App.views.PostTagPills({
                    post: me.model,
                    postTagsById: _.keyBy(me.options.postTags, 'id') || {},
                    parentDashboardModel: me.dashboardModel,
                    postTagsClickable: false,
                    showActionBtns: false // no post tag action allowed in post modal
                }));
            }
        }
    });


}, window.s);
